import { render, staticRenderFns } from "./BaseUpload.vue?vue&type=template&id=71c91fbf&scoped=true&"
import script from "./BaseUpload.vue?vue&type=script&lang=js&"
export * from "./BaseUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c91fbf",
  null
  
)

export default component.exports